import { Injectable, makeStateKey, TransferState } from '@angular/core';
import { PlatformService } from '../platform/platform.service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ETransferState } from '../../core/enums';
import { ISeoItem } from '../../core/interfaces';
import { environment } from '../../../environments/environment';

const PAGE_TITLE_KEY = makeStateKey<ISeoItem | null>(ETransferState.pageTitle);

@Injectable({
  providedIn: 'root'
})
export class PagetitleService {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private transferState: TransferState,
    private platform: PlatformService
  ) { }

  setTitle(meta: ISeoItem, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    let pageSeo = this.transferState.get<ISeoItem | null>(PAGE_TITLE_KEY, null);
    if (pageSeo) {
      this.titleService.setTitle(pageSeo.title);
      this.metaService.updateTag({ name: 'description', content: meta.description });
      this.transferState.remove(PAGE_TITLE_KEY);
    } else {
      pageSeo = meta;
      this.titleService.setTitle(pageSeo.title);
      this.metaService.updateTag({ name: 'description', content: meta.description });
      if (this.platform.isPlatformServer()) {
        this.transferState.set(PAGE_TITLE_KEY, pageSeo);
      }
    }

    const robots = environment.allowSearchIndexing ? 'index,follow' : 'noindex,nofollow,noarchive,nosnippet';
    this.metaService.updateTag({ name: 'robots', content: robots });
    this.metaService.updateTag({ name: 'googlebot', content: robots });
  }
}
